module.exports = __webpack_public_path__ + "static/media/PaypalIcon.481cb51a.svg";